<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <label>Nome</label>
        <input
          type="text"
          class="form-control"
          v-model="name"
          ref="autofocus"
        />
      </div>
      <div class="col-md-4">
        <label>Cor</label>
        <input type="color" class="form-control" v-model="color" />
      </div>
      <div class="col-md-12">
        <label>Tipo de categoria</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="typeCategory"
              id="parent"
              value="parent"
            />
            <label class="form-check-label" for="parent">Categoria pai</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="typeCategory"
              id="daughter"
              value="daughter"
            />
            <label class="form-check-label" for="daughter"
              >Categoria filha</label
            >
          </div>
        </div>
      </div>
      <div v-if="type == 'daughter'" class="col-md-12">
        <label>Categoria pai</label>
        <treeselect
          :options="parents"
          placeholder="SELECIONE..."
          v-model="parent_id"
          noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
        />
        <small v-if="parents.length == 0"
          >Não possui categoria pai cadastrado!</small
        >
      </div>
      <div class="col-md-6">
        <label>Classificação</label>
        <div>
          <v-btn
            :class="[classification == 'MISTA' && 'v-dark']"
            @click="handleClickClassification('MISTA')"
            >MISTA</v-btn
          >
          <v-btn
            :class="[classification == 'DESPESA' && 'v-dark']"
            @click="handleClickClassification('DESPESA')"
            >DESPESA</v-btn
          >
          <v-btn
            :class="[classification == 'RECEITA' && 'v-dark']"
            @click="handleClickClassification('RECEITA')"
            >RECEITA</v-btn
          >
        </div>
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" @click="create" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "Create",

  components: {
    ErrorsMessages,
    Treeselect,
  },

  data() {
    return {
      sortValueBy: "ORDER_SELECTED", // ORDER_SELECTED || LEVEL || INDEX
      name: "",
      color: "",
      type: "",
      classification: "",
      parent_id: null,
      parents: [],
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
    setTimeout(() => this.$refs.autofocus.focus(), 200);
  },

  methods: {
    handleInputType() {
      this.parent_id = "";
      this.classification = "";
    },

    handleClickClassification(classification) {
      let { type } = this;

      if (type == "daughter") {
        return;
      }

      this.classification = classification;
    },

    handleSelectParentCategoryId() {
      let { parent_id, parents } = this;

      let parent = parents.find(({ id }) => id == parent_id);

      if (parent) {
        this.classification = parent.classification;
        this.color = parent.color;
      }
    },

    retrieve() {
      this.color = `#${Math.floor(Math.random() * 0x1000000)
        .toString(16)
        .padStart(6, "0")}`;

      this.getParents();
    },

    async getParents() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/configuration/category-all"
        );

        const { data } = response.data;

        this.parents = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        const { name, color, type, classification, parent_id } = this;

        let params = { name, color, type, classification, parent_id };

        const response = await api.post(
          "/rest-home/financial/configuration/category",
          params
        );

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide("create");

          this.$emit("success", id);

          this.name = "";
          this.color = "";
          this.type = "";
          this.classification = "";
          this.parent_id = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
